/*
 * @Date: 2024-03-11 17:10:12
 * @LastEditors: fangdong dong.fang@quvideo.com
 * @LastEditTime: 2024-03-11 17:10:39
 * @FilePath: /video-marketing/config/oversea.ts
 */
export const overseaConfig = {
  APP_LANDING: 'https://boomcut.ai',
} as const;
